import MuiAvatar from '@mui/material/Avatar';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
// import { stringToColor } from 'utils/str-to-color';

const sizeMap = {
  xsmall: 28,
  small: 32,
  medium: 36,
  large: 40,
  xlarge: 52,
  xxlarge: 68,
  '3xlarge': 80,
  '4xlarge': 100,
};

const StyledAvatar = styled(MuiAvatar)(
  ({ theme, size = 'medium', color = 'primary', fillMode = 'light' }) => ({
    width: sizeMap[size],
    height: sizeMap[size],
    fontSize: sizeMap[size] / 2.8,
    fontWeight: 600,
    backgroundColor:
      fillMode === 'dark'
        ? theme.palette[color].main
        : theme.palette[color].subtle,
    color:
      fillMode === 'dark'
        ? theme.palette[color].contrastText
        : theme.palette[color].main,
    '& .MuiSvgIcon-root': {
      fontSize: sizeMap[size] / 1.7,
    },
  }),
);

function stringAvatar(name = '') {
  const [one, two = ''] = name.split(' ');
  return {
    children: `${one[0]}${two[0] || ''}`.trim().toUpperCase(),
  };
}

const Avatar = ({ name, children, fillMode, ...props }) => {
  if (typeof name === 'string') {
    return (
      <StyledAvatar {...props} {...stringAvatar(name)} fillMode={fillMode} />
    );
  }
  if (typeof children === 'string') {
    return (
      <StyledAvatar
        {...stringAvatar(children)}
        {...props}
        fillMode={fillMode}
      />
    );
  }
  return (
    <StyledAvatar fillMode={fillMode} {...props}>
      {children}
    </StyledAvatar>
  );
};

Avatar.propTypes = {
  size: PropTypes.oneOf([
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge',
    'xxlarge',
    '3xlarge',
    '4xlarge',
  ]),
  src: PropTypes.string,
  name: PropTypes.string,
  children: PropTypes.node,
  color: PropTypes.oneOf([
    'primary',
    'secondary',
    'success',
    'error',
    'warning',
  ]),
  fillMode: PropTypes.oneOf(['light', 'dark']),
};

export default Avatar;
